// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"101":"3d486261","161":"f56f95af","507":"54384f24","820":"3eea3c99"}[chunkId] + ".css";
};